import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";



function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    

    const handleLogin = async (e) => {
    e.preventDefault();
    console.log("Login button clicked"); 

    try {
        const url = `https://unito-backend.onrender.com/unito/login`;
        console.log("Gonna sent request to "+ url);
        const response = await axios.post(
            url,
            { username, password },
            {
                headers: {
                    "Content-Type": "application/json"
                },
                withCredentials: true
            }
            
        );
        console.log("Login successful:", response.data);
        alert("Welcome " + username + "!");
        const token = response.data.token;
        if (token) {
        try {
        Cookies.set("token",token, { expires: 1 })
        // localStorage.setItem("token", token);
        console.log("Token saved successfully!");
        } catch (err) {
        console.error("Failed to save token:", err);
        }
            navigate('/profile');
        } else {
            alert("Login failed. No token received from server.");
        }
    } catch (error) {
        console.error("Login failed:", error.response ? error.response.data : error.message);
        alert("Login failed. Server error or invalid credentials.");
    }
};

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-violet-300 to-pink-300">
            <div className="bg-white shadow-xl rounded-lg p-10 w-full max-w-md">
                <h2 className="text-3xl font-bold text-center text-gray-800 mb-2">Welcome Back</h2>
                <p className="text-center text-gray-500 mb-6">Log in to continue 🚀</p>

                <form onSubmit={handleLogin} className="space-y-5">
                    {/* Username Input */}
                    <div>
                        <label htmlFor="username" className="block text-sm font-semibold text-gray-700 mb-1">
                            Username
                        </label>
                        <input
                            type="text" 
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                    </div>

                    {/* Password Input */}
                    <div>
                        <label htmlFor="password" className="block text-sm font-semibold text-gray-700 mb-1">
                            Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="w-full bg-violet-500 hover:bg-violet-600 text-white font-semibold py-2 rounded-md transition duration-200"
                    >
                        Login
                    </button>
                </form>

                {/* Link to Register */}
                <p className="text-sm text-center text-gray-500 mt-6">
                    Don’t have an account?{" "}
                    <Link to="/register" className="text-violet-600 hover:underline">
                        Register here
                    </Link>
                </p>
            </div>
        </div>
    );
}

export default Login;
